import { CompletionType, NOT_COMPLETE } from '../../../../../../constants/constants';
import { List, Photo, Task, User } from '../../../interfaces/objects';
import { OrgSettingKey } from '../../../../../../features/settings/orgSettings/orgSettingsConstants';

export interface SyncedRecord {
  syncedOn?: Date;
}

export class DexieList extends List implements SyncedRecord {
  public syncedOn?: Date;
}

export class DexieTask extends Task implements SyncedRecord {
  public syncedOn?: Date;
}

export class DexieCompletionCache {
  public taskId: string = '';
  public listId: string = '';

  public cacheId: string = '';

  public dueDate?: Date | null;
  public notes?: string;
  public completedOn?: Date;
  public completedBy?: string;
  public isCompleted: CompletionType = NOT_COMPLETE; // boolean is not indexable in IndexedDB, though they do have a "binary" type that is an unsigned byte values (https://www.w3.org/TR/IndexedDB/#key-construct)

  public completionPhotoIds?: string[];
  /**
   * Set based on tasks downloaded from the server.
   * Indicates photos for the task on the server that are not yet downloaded.
   */
  public pendingPhotos?: string[];
}

export class DexiePhoto extends Photo {
  public cacheTime?: Date;
}

/**
 * Marker that a completion photo has been saved locally but its COMPLETION_ADD_PHOTO change log has not
 * been queued yet (the resize + queue runs in the background). If the app is closed before that finishes,
 * the marker survives so startup recovery can re-create the add from the saved local photo.
 */
export class DexiePendingPhotoAdd {
  public photoId: string = '';
  public taskId: string = '';
  /** When the photo was captured; the recovered change log is stamped with this so it still sorts before any tag edit. */
  public capturedAt: number = 0;
}

export class DexieUser extends User implements SyncedRecord {
  public syncedOn?: Date;
}

export class DexieSetting {
  public key: OrgSettingKey = OrgSettingKey.UNDEFINED;
  public value: string | null = null;
}
